import React from 'react';
import { Form, Button } from 'components';
import { Alert, VerticalSpace } from '@brokerbay/design-components';
import { PASSWORD_REGEX } from 'utils/constants';
import { StyledPasswordInput } from './common';

export type OnboardingSetPasswordFormValue = {
  password: string;
  passwordConfirmation: string;
};

export type OnboardingSetPasswordFormProps = {
  loading?: boolean;
  onSubmit: (values: OnboardingSetPasswordFormValue) => void;
};

export const OnboardingSetPasswordForm: React.FC<
  OnboardingSetPasswordFormProps
> = props => {
  const { loading = false, onSubmit } = props;

  return (
    <VerticalSpace>
      <Alert
        message="Your password must have a minimum of 8 characters, have 1 letter, 1 number, and 1 capital"
        type="info"
      />
      <Form
        name="onboardingSetPasswordForm"
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: 'Password is required' },
            {
              pattern: new RegExp(PASSWORD_REGEX),
              message:
                'Must have a minimum of 8 characters, have 1 letter, 1 number, and 1 capital',
            },
          ]}
        >
          <StyledPasswordInput />
        </Form.Item>
        <Form.Item
          name="passwordConfirmation"
          label="Re-enter Password"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Password confirmation is required' },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue('password') === value)
                  return Promise.resolve();
                return Promise.reject(new Error('Passwords must match'));
              },
            }),
          ]}
        >
          <StyledPasswordInput />
        </Form.Item>

        <Button
          type="primary"
          block
          htmlType="submit"
          disabled={loading}
          loading={loading}
        >
          Next
        </Button>
      </Form>
    </VerticalSpace>
  );
};
